// extracted by mini-css-extract-plugin
export default {"root":"CustomizedLegend_root__KvtK9","item":"CustomizedLegend_item__xfcMb","colorMark":"CustomizedLegend_colorMark__oDy2g","text":"CustomizedLegend_text__Md4rP"};